import Loader from "components/shared/Loader";
import React, { useEffect, useMemo, useState } from "react";
import Debounce from "utilities/Debounce";
import useApp from "hooks/useApp";
import { FiChevronDown, FiChevronRight, FiChevronLeft } from "react-icons/fi";
import classNames from "utilities/ClassNames";
import OrganizationHeader from 'components/organization/OrganizationHeader';
import OrganizationTabs from 'components/organization/OrganizationTabs';
import OrganizationActionMenu from "components/organization/OrganizationActionMenu";
import OrganizationModal from "components/Modal/OrganizationModal";
import ConfirmationModal from "components/Modal/ConfirmationModal";
import { removeOrganization } from "api/organizations";
import ProjectReassignModal from "components/Modal/ProjectReassignModal";
import { demoOrganizationsMockData } from "@/lib/constants";
import UsersTable from "components/organization/UsersTable";
import { getAllOrganizations, getAllOrganizationUsers, getAllUsersWithOrganization } from "api/users";



export default function Users() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [organizations, setOrganizations] = useState<any>([]);
  const [expandedOrg, setExpandedOrg] = useState<number | null>(null);
  const { isScaled } = useApp();
  const [activeTab, setActiveTab] = useState('organizations');
  const [refreshMode, setRefreshMode] = useState('');
  const [editOrg, setEditOrg] = useState<any>(null);
  const [deleteOrg, setDeleteOrg] = useState<any>(null);
  const [selectedUser, setSelectedUser] = useState<any>(null);
  
  const [users, setUsers] = useState<any>([]);
  const [orgUsers, setOrgUsers] = useState<any>([]);
  const [keyword, setKeyword] = useState("");
  const [debouncedKeyword, setDebouncedKeyword] = useState("");
  const [loadingUsers, setLoadingUsers] = useState(false);
  Debounce(() => setDebouncedKeyword(keyword), [keyword], 500);


  const getUsersWithOrganization = async () => {
    try { 
      setLoading(true);
      setLoadingUsers(true);
      const usersLists: any = await getAllUsersWithOrganization();
      const organizationsLists: any = await getAllOrganizations();
      if (usersLists.status === 200) {
        if (usersLists.data.list.length > 0) {
          setUsers(usersLists.data.list);
        }
      }
      if (organizationsLists.status === 200) {
        if (organizationsLists.data.list.length > 0) {
          setOrganizations(organizationsLists.data.list);
        }
      }
      setLoading(false);
      setLoadingUsers(false);
    } catch (error) {
      setLoading(false);
      setLoadingUsers(false);
    }
  };

  const getOrganizationUsers = async (id:any) => {
    try {
      setLoadingUsers(true);
      const organizationUsersLists: any = await getAllOrganizationUsers(id);
      if (organizationUsersLists.status === 200) {
        if (organizationUsersLists.data.list.length > 0) {
          setOrgUsers(organizationUsersLists.data.list);
        }
      }
      setLoadingUsers(false);
    } catch (error) {
      setLoadingUsers(false); 
    }
  };

    

  useEffect(() => {
    getUsersWithOrganization();
  }, []);

  useEffect(() => {
    if (refreshMode === 'organizations') {
      getUsersWithOrganization();
    }
  }, [refreshMode]);

  const handleRoleChange = (userId: string, newRole: string) => {
    setUsers((prevUsers: any) => 
      prevUsers.map((user: any) => 
        user.id === userId 
          ? { ...user, userType: newRole }
          : user
      )
    );
  };

  const [orgFilters, setOrgFilters] = useState({
    organization: '',
    subscriptionType: '',
    billingPeriod: '',
    paymentStatus: '',
    search: ''
  });

  const [userFilters, setUserFilters] = useState({
    organization: '',
    status: '',
    paymentStatus: '',
    paymentMethod: '',
    subscriptionType: '',
    userType: '',
    search: ''
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const filteredOrgData = useMemo(() => {
    let filtered = [...organizations];
    
    if (orgFilters?.search) {
      const searchTerm = orgFilters?.search?.toLowerCase();
      filtered = filtered?.filter((org:any) => 
        org?.name?.toLowerCase()?.includes(searchTerm) ||
        org?.desc?.toLowerCase()?.includes(searchTerm) ||
        org?.product?.toLowerCase()?.includes(searchTerm) ||
        org?.createdBy?.toLowerCase()?.includes(searchTerm)
      );
    }
    
    if (orgFilters?.organization) {
      filtered = filtered?.filter((org:any) => org?.name?.includes(orgFilters?.organization));
    }
    
    if (orgFilters?.subscriptionType) {
      filtered = filtered?.filter((org:any) => 
        org?.users?.some((user:any) => user?.subscriptionType === orgFilters?.subscriptionType)
      );
    }
    
    return filtered;
  }, [organizations, orgFilters]);

  // Calculate pagination
  const totalPages = Math.ceil((filteredOrgData?.length || 0) / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const handleDelete = async () => {
    if (deleteOrg) {
      try {
        await removeOrganization(deleteOrg);
        setRefreshMode('organizations');
        setOrganizations(organizations.filter((org:any) => org.id !== deleteOrg.id));
      } catch (error) {
        console.error('Error deleting organization:', error);
      }
      setDeleteOrg(null);
    }
  };

  return (
    <>
      {loading && (
        <div className="w-full h-[80vh] grid place-content-center">
          <Loader />
        </div>
      )}
      {error && (
        <div className="w-full h-[80vh] grid place-content-center">
          <p>Error loading data</p>
        </div>
      )}
      {!loading && !error && organizations && (
        <div className={classNames(
          isScaled ? "text-base" : "text-base",
          "px-6 pb-3 overflow-hidden overflow-y-auto h-full"
        )}>
          <div className="pt-6 mb-6">
            <OrganizationHeader />
          </div>

          
          {/* <OrganizationTabs 
            activeTab={activeTab} 
            onTabChange={setActiveTab}
            setRefreshMode={setRefreshMode}
            setOrgFilters={setOrgFilters}
            setUserFilters={setUserFilters}
            orgFilters={orgFilters}
            userFilters={userFilters}
            users={users}
            handleRoleChange={handleRoleChange} 
            loadingUsers={loadingUsers}
          > */}

         
              <UsersTable filters={userFilters} users={users} handleRoleChange={handleRoleChange}
              loadingUsers={loadingUsers}
              />
          {/* </OrganizationTabs> */}

          {/* {activeTab === 'organizations' && filteredOrgData && filteredOrgData.length > 0 && (
            <div className="flex justify-between items-center mt-4 px-4">
              <div className="text-sm text-gray-400">
                Showing {startIndex + 1} to {Math.min(endIndex, filteredOrgData.length)} of {filteredOrgData.length} entries
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                  disabled={currentPage === 1}
                  className="p-2 text-gray-400 hover:text-white disabled:opacity-50"
                >
                  <FiChevronLeft />
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`w-8 h-8 rounded-lg ${
                      currentPage === page
                        ? 'bg-blue-600 text-white'
                        : 'text-gray-400 hover:text-white'
                    }`}
                  >
                    {page}
                  </button>
                ))}
                <button
                  onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                  className="p-2 text-gray-400 hover:text-white disabled:opacity-50"
                >
                  <FiChevronRight />
                </button>
              </div>
            </div>
          )} */}
        </div>
      )}

      <OrganizationModal
        isOpen={!!editOrg}
        onClose={() => setEditOrg(null)}
        mode="edit"
        initialData={editOrg}
        setRefreshMode={setRefreshMode}
      />

      <ConfirmationModal
        isOpen={!!deleteOrg}
        message="Are you sure you want to delete this organization?"
        onConfirm={handleDelete}
        onCancel={() => setDeleteOrg(null)}
      />

      <ProjectReassignModal
        isOpen={!!selectedUser}
        onClose={() => setSelectedUser(null)}
        userData={demoOrganizationsMockData[0]?.users[0] as any}
        allUsers={demoOrganizationsMockData[0]?.users as any}
      />

    </>
  );
}
